var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "12" } },
            [
              _c(
                "vs-divider",
                { staticClass: "mt-10 font-bold", attrs: { position: "left" } },
                [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v(
                      "Taux de réponses: " +
                        _vm._s(
                          Math.round(
                            (_vm.resource.ratings.length /
                              _vm.resource.affected_users_count) *
                              100
                          )
                        ) +
                        "%"
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "vx-row mb-6" }, [
                _c("div", { staticClass: "vx-col w-full" }, [
                  _c("span", [
                    _vm._v(
                      "Taux de réponses totales: " +
                        _vm._s(
                          Math.round(
                            (_vm.resource
                              .ratings_with_all_closed_questions_replied /
                              _vm.resource.ratings.length) *
                              100
                          )
                        ) +
                        "%"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx-col w-full" }, [
                  _c("span", [
                    _vm._v(
                      "Taux de réponses partielles: " +
                        _vm._s(
                          Math.round(
                            100 -
                              (_vm.resource
                                .ratings_with_all_closed_questions_replied /
                                _vm.resource.ratings.length) *
                                100
                          )
                        ) +
                        "%"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "vs-divider",
                { staticClass: "mt-10 font-bold", attrs: { position: "left" } },
                [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v("Pourcentage d'appréciations globales: 88%"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(
                _vm.resource.synthesis_v0_from_ia_with_file,
                function (response, question) {
                  return [
                    _c(
                      "vs-divider",
                      {
                        staticClass: "mt-10 font-bold",
                        attrs: { position: "left" },
                      },
                      [
                        _c("p", { staticClass: "bold" }, [
                          _vm._v(_vm._s(question) + " :"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "vx-row mb-6" }, [
                      _c("div", {
                        staticClass: "vx-col w-full",
                        domProps: { innerHTML: _vm._s(response) },
                      }),
                    ]),
                  ]
                }
              ),
              _vm._v(" "),
              _c(
                "vs-divider",
                { staticClass: "mt-10 font-bold", attrs: { position: "left" } },
                [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v("Synthèse des questions fermées :"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.grids, function (grid, i) {
                return _c(
                  "div",
                  { key: "table_grid_" + i, staticClass: "mb-10" },
                  [
                    _c(
                      "vs-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "no-data-text": ``,
                          data: grid.closed_questions,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ data }) {
                                return _vm._l(
                                  data,
                                  function (closed_question, j) {
                                    return _c(
                                      "vs-tr",
                                      {
                                        key:
                                          "grid_" + i + "_closed_question_" + j,
                                      },
                                      [
                                        _c("vs-td", { staticClass: "center" }, [
                                          _vm._v(_vm._s(closed_question.title)),
                                        ]),
                                        _vm._v(" "),
                                        _c("vs-td", { staticClass: "center" }, [
                                          _c(
                                            "div",
                                            {
                                              class:
                                                "colored-block " +
                                                _vm.colors[0],
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  (closed_question.param_0 /
                                                    closed_question.all_param) *
                                                    100
                                                ) + "%"
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.ratingParams,
                                          function (param, p) {
                                            return _c(
                                              "vs-td",
                                              {
                                                key: "body_param" + p,
                                                staticClass: "center",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    class:
                                                      "colored-block " +
                                                      _vm.colors[param.id],
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (closed_question[
                                                          "param_" + param.id
                                                        ] /
                                                          closed_question.all_param) *
                                                          100
                                                      ) + "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c("vs-td", { staticClass: "center" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "colored-block white",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.resource.ratings
                                                    ? (closed_question.leveled_params /
                                                        _vm.resource.ratings
                                                          .length) *
                                                        100
                                                    : "NA"
                                                ) + "%"
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      2
                                    )
                                  }
                                )
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("h4", { staticClass: "mb-1" }, [
                            _vm._v(_vm._s(grid.title)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "thead" },
                          [
                            _c("vs-th", [_vm._v("Question")]),
                            _vm._v(" "),
                            _c("vs-th", [_vm._v("Sans avis")]),
                            _vm._v(" "),
                            _vm._l(_vm.ratingParams, function (param, p) {
                              return _c("vs-th", { key: "head_param" + p }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(param.label) +
                                    "\n                        "
                                ),
                              ])
                            }),
                            _vm._v(" "),
                            _c("vs-th", [_vm._v("Taux de réponses")]),
                          ],
                          2
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }